import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import { ConstructionOutlined } from '@mui/icons-material';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import * as React from 'react';
import tippy, {followCursor} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/shift-away.css';



export default function CoGenPlanTimeline(props) {

    const PALETTE = [
        [26, 13, 171],   // Deep Blue
        [0, 100, 0],     // Deep Forest Green
        [70, 70, 70],    // Charcoal Gray
        [128, 0, 32],    // Burgundy
        [25, 25, 112],   // Midnight Blue
        [94, 128, 22],   // Moss Green
        [106, 90, 205],  // Slate Blue
        [139, 69, 19],   // Cocoa Brown
        [139, 102, 139], // Plum
        [128, 70, 27],   // Russet Brown
      ];

    const { t } = useTranslation();

    const calendarRef = React.useRef();

    const {events, localTimezone} = props;

    const sortedEvents = events.slice().sort((a,b) => (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0));

    const date = (sortedEvents.length>0) ? moment.tz(sortedEvents[0].timestamp, localTimezone).format("YYYY-MM-DD") : "2020-01-01";

    React.useEffect(() => 
    {
        let calendarApi = calendarRef.current.getApi();     
        calendarApi.gotoDate(date);
    },
    [events]
    )   

    const calendarEvents = [];

    const generators = [];
    events.map((e)=>{
        if (generators.filter((g)=>g.id === e.generator).length === 0) {
            generators.push({
                id: e.generator,
                title: e.generator_name
            })
        }
    })

    generators.map((g, gindex)=>{

        const generatorEvents = sortedEvents.filter((e)=>e.generator === g.id);

        generatorEvents.slice(0, -1).map(
            (e, i) => {
                if (e.value !== "OFF"){
                    calendarEvents.push({
                        id: e.url,
                        start: moment.tz(e.timestamp, localTimezone).format(),
                        end: moment.tz(generatorEvents[i + 1].timestamp, localTimezone).format(),
                        value: e.value,
                        value_percentage: e.value_percentage,
                        resourceId: e.generator,
                        title: `${e.value_percentage.toFixed()}%`,
                        color: `rgba(${PALETTE[gindex % PALETTE.length].join(",")}, ${0.85*e.value_percentage/100.0 + 0.15})`
                    })
                }
            }
        )

        if (generatorEvents.length > 0){

            const lastEvent = generatorEvents.slice(-1)[0];

            const endTime = moment.tz(`${date}T00:00:00`, localTimezone).add(1, "days").format()

            if (lastEvent.value !== "OFF"){
                calendarEvents.push({
                    id: lastEvent.url,
                    start: moment.tz(lastEvent.timestamp, localTimezone).format(),
                    end: endTime,
                    value: lastEvent.value,
                    value_percentage: lastEvent.value_percentage,
                    resourceId: lastEvent.generator,
                    title: `${lastEvent.value_percentage.toFixed()}%`,
                    color: `rgba(${PALETTE[gindex % PALETTE.length].join(",")}, ${0.85*lastEvent.value_percentage/100.0 + 0.15})`
                })
            }
        }

    })


    const handleEventMount = (arg) =>{

        tippy(arg.el, {
            content:  `${arg.event.extendedProps.value_percentage.toFixed()}% (${arg.event.extendedProps.value} MW)`,
            followCursor: true,
            plugins: [followCursor]
        });
    }

    return (
        <FullCalendar
            ref={calendarRef}
            timeZone={localTimezone}
            plugins={[ resourceTimelinePlugin  ]}
            initialView="resourceTimeline"
            resources={generators}
            events={calendarEvents}
            schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
            contentHeight={"auto"}
            headerToolbar={null}
            resourceAreaColumns={[
                {
                  field: 'title',
                  headerContent: t('Generator')
                }
              ]}
   
            eventDidMount={handleEventMount}
            
            resourceAreaWidth={200}
        />
    );

};